import { lazyLoad } from 'utils/loadable';

export const Notifications = lazyLoad(() => import('./index'));
